import {Injectable, OnInit} from '@angular/core';
import {AppConfigService} from "../../config/app-config.service";
import {DeviceDetectorService} from "ngx-device-detector";
import {Browser} from "./browser";

@Injectable({
  providedIn: 'root'
})
export class DetectBrowserService implements OnInit{

  private readonly supportedBrowsers: Browser[];

  private browserCompatible: boolean = undefined;
  private _browserVersionSupported: boolean = true;
  private errorMessageKey: string;

  constructor(private appConfig: AppConfigService, private detectService: DeviceDetectorService) {
    this.supportedBrowsers = this.appConfig.supportedBrowsers;
  }

  ngOnInit(): void {

  }

  getErrorMessageKey(): string | undefined{
    return this.errorMessageKey;
  }

  isMobile(): boolean {
    return this.detectService.isMobile() || this.detectService.isTablet();
  }

  getOs(): string | undefined {
    return this.detectService.os;
  }

  getOsVersion(): string | undefined {
    return this.detectService.os_version;
  }

  getBrowser(): string | undefined {
    return this.detectService.browser;
  }

  getBrowserObject(): Browser | undefined {
    return this.getSupportedBrowser(this.getBrowser());
  }

  getSupportedBrowser(browser: string): Browser | undefined{
    return this.supportedBrowsers.find( b => b.browser === browser);
  }

  getSupportedBrowsers(): Browser[] {
    return this.supportedBrowsers;
  }
  
  getBrowserVersion(): string | undefined {
    return this.detectService.browser_version;
  }
  isBrowserCompatible(){
    return this.browserCompatible === undefined ? this.isBrowserSupported() : this.browserCompatible;
  }
  
  private isBrowserSupported(): boolean {
    const browser = this.getSupportedBrowser(this.getBrowser());
    this.browserCompatible = (browser !== undefined);
    if(!this.browserCompatible) {
      this.errorMessageKey = 'Error.browser.notSupported';
      console.error(this.getBrowser());
      return false;
    }
    if(+browser.version > +this.getVersion(this.getBrowserVersion())){
      this.browserCompatible = false;
      this._browserVersionSupported = false;
      this.errorMessageKey = 'Error.browser.version.notSupported';
      console.error(this.getVersion(this.getBrowserVersion()));
      return false;
    }
    this.browserCompatible = true;
    this._browserVersionSupported = true;
    return true;
  }

  private getVersion(version: String){
    if(version) {
      let splittedVersion = version.split('.', 1);
      return splittedVersion[0];
    }
    return undefined;
  }

  isBrowserVersionSupported(): boolean {
    return this._browserVersionSupported;
  }
}
